const apiUrl = process.env.REACT_APP_API_URL;

const getVisualInspectionTimings = (token, cb) => {
    fetch(`${apiUrl}/visualinspectiontimings`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getVisualInspectionTimings;
